<template>
  <div class="batteryConsignRecordProcessView">
    <div class="list">
      <div class="name-label">寄存记录编号：</div>
      <div class="value-label">{{ recordNo }}</div>
      <div class="name-label">换电柜编号：</div>
      <div class="value-label">{{ primaryDeviceNo }}</div>
      <div class="name-label">电池通讯板号：</div>
      <div class="value-label">{{ communicationBoardNo }}</div>
    </div>
    <div class="list">
      <div class="blue-btn" @click="onQueryBtnClick">查看设备快照</div>
      <div class="blue-btn ml10" style="width: 100px" @click="onQueryRecordClick">查看发送请求记录</div>
    </div>
    <el-steps class="step" direction="vertical" space="70px" :active="activeStep" v-if="type==1">
      <el-step :title="chargePortSeq+'号柜门'+(stepOne=='active'?'已打开':'正在打开')"></el-step>
      <span v-if="status=='dealing' && step=='0' && nextStepLeftTime>-1" class="left-time"
            style="top:136px">剩余完成时间{{ nextStepLeftTime }}秒</span>
      <el-step title="请放入电池并关闭柜门" description="请务必确认插好电池"></el-step>
      <span v-if="status=='dealing' && (step=='1' || step=='2') && nextStepLeftTime>-1" class="left-time"
            style="top:206px">剩余完成时间{{ nextStepLeftTime }}秒</span>
    </el-steps>
    <el-steps class="step" direction="vertical" space="70px" :active="activeStep" v-if="type==2">
      <el-step :title="chargePortSeq+'号柜门'+(stepOne=='active'?'已打开':'正在打开')"></el-step>
      <span v-if="status=='dealing' && step=='3' && nextStepLeftTime>-1" class="left-time"
            style="top:276px">剩余完成时间{{ nextStepLeftTime }}秒</span>
      <el-step title="请取出电池并关闭柜门"></el-step>
      <span v-if="status=='dealing' && step=='4' && nextStepLeftTime>-1" class="left-time"
            style="top:346px">剩余完成时间{{ nextStepLeftTime }}秒</span>
    </el-steps>
    <div class="list" style="margin-top: 0">
      <div class="red" v-if="status=='fail'">{{ failReason }}</div>
    </div>
    <div class="list">
      <div class="normal-btn fixed-width-125" @click="cancel" v-if="status=='success'||status=='fail'">
        {{ status == 'success' ? '已成功，确认返回' : '已失败，确认返回' }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'batteryConsignRecordProcessView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      recordNo: "",
      communicationBoardNo: "",
      primaryDeviceNo: "",
      type: "",
      status: "",
      chargePortSeq: "",
      step: "",
      activeStep: 0,
      stepOne: '',
      stepTwo: '',
      stepThree: '',
      nextStepLeftTime: "",
      operateAbleChargePortSeqNo: "-1",
      failReason: "",
      queryResultInterval: null,
    }
  },
  watch: {
    editData: {
      handler() {
        this.recordNo = this.editData.number;
        this.communicationBoardNo = this.editData.communicationBoardNo;
        this.type = this.editData.type;
        this.queryBatteryConsignRecordStep();
      },
      deep: true,
    },
  },
  mounted() {
    let self = this;
    this.queryResultInterval = setInterval(self.queryBatteryConsignRecordStep, 1000)
  },
  destroyed() {
    this.clearQueryResultInterval();
  },
  methods: {
    queryBatteryConsignRecordStep() {
      let self = this;
      let params = {
        recordNo: this.recordNo
      };
      this.$http.post('/electricity/battery/consign/queryBatteryConsignRecordStep', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        let status = res.mdata.status;
        let step = res.mdata.step;
        let nextStepLeftTime = res.mdata.nextStepLeftTime || -1;
        let operateAbleChargePortSeqNo = res.mdata.operateAbleChargePortSeqNo;
        let failReason = res.mdata.failReason || "";
        self.primaryDeviceNo = res.mdata.primaryDeviceNo;
        self.status = status;
        self.step = step;
        self.nextStepLeftTime = nextStepLeftTime;
        self.chargePortSeq = res.mdata.chargePortSeqNo;
        self.failReason = failReason;
        self.operateAbleChargePortSeqNo = operateAbleChargePortSeqNo;
        if (res.mdata.terminate) {
          self.clearQueryResultInterval();
        }
        if (self.type == 1) {
          if (step == 1) {
            self.stepOne = 'active';
            self.activeStep = 1;
          } else if (step == 2) {
            self.stepOne = 'active';
            self.stepTwo = 'active';
            self.activeStep = 2;
          } else if (step == 3) {
            self.stepOne = 'active';
            self.stepTwo = 'active';
            self.stepThree = 'active'
          }
        } else if (self.type == 2) {
          if (step == 1) {
            self.stepOne = 'active';
            self.activeStep = 1;
          } else if (step == 2) {
            self.stepOne = 'active';
            self.stepTwo = 'active';
            self.activeStep = 2;
          }
        }
        // if (step == 1) {
        //     self.stepOne = 'active';
        //     self.activeStep = 1;
        // } else if (step == 2) {
        //     self.stepOne = 'active';
        //     self.stepTwo = 'active';
        //     self.activeStep = 2;
        // } else if (step == 3) {
        //     self.stepOne = 'active';
        //     self.stepTwo = 'active';
        //     self.stepThree = 'active'
        // } else if (step == 4) {
        //     self.stepOne = 'active';
        //     self.stepTwo = 'active';
        //     self.stepThree = 'active';
        //     self.stepFour = 'active'
        //     self.activeStep = 3;
        // } else if (step == 5) {
        //     self.stepOne = 'active';
        //     self.stepTwo = 'active';
        //     self.stepThree = 'active';
        //     self.stepFour = 'active';
        //     self.stepFive = 'active';
        //     self.activeStep = 4;
        // }
      }).catch(function (response) {
        console.log(response);
      });
    },
    clearQueryResultInterval: function () {
      this.queryResultInterval && clearInterval(this.queryResultInterval);
      this.queryResultInterval = null;
    },
    cancel() {
      this.$emit('cancel');
    },
    onQueryBtnClick() {
      this.$router.push("/managePage/batteryConsignRecordBatterySnap?recordNo=" + this.recordNo + "&primaryDeviceNo=" + this.primaryDeviceNo + "&chargePortSeq=" + this.chargePortSeq + "&type=" + this.type);
    },
    onQueryRecordClick() {
      let sourceType;
      if (this.type == 1) {
        sourceType = 20;
      } else if (this.type == 2) {
        sourceType = 22;
      }
      this.$router.push("/managePage/batteryConsignSendRequestRecord?recordNo=" + this.recordNo + "&sourceType=" + sourceType + "&type=" + this.type);
    },
  },
}
</script>
<style lang="scss" scoped>
.main-body {
  min-height: 50px;
}

.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .fixed-width-125 {
    width: 125px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.step {
  padding: 20px 30px;

  .left-time {
    position: absolute;
    left: 250px;
    color: red;
  }
}

.red {
  color: red;
}

.ml-40 {
  margin-left: 40px;
}

.bbn {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batteryConsignRecordProcessView.vue